import {
  AdminEndpointEnum,
  AevoEndpointEnum,
  DeribitEndpointEnum,
  BinanceEndpointEnum,
  BybitEndpointEnum,
  TradingParametersEndpointEnum,
} from "../enums/endpoints";

type PollingIntervalKey = AdminEndpointEnum | AevoEndpointEnum | DeribitEndpointEnum | BinanceEndpointEnum | BybitEndpointEnum | TradingParametersEndpointEnum;

// Keeps track of the polling interval for each endpoint
// in milliseconds
export const pollingInterval: { [key in PollingIntervalKey]?: number } = {
  [AdminEndpointEnum.ACCOUNT]: 60000,
  [AdminEndpointEnum.ACCOUNT_TRADES]: 60000,
  [AdminEndpointEnum.ACCOUNT_TXS]: 60000,
  [AdminEndpointEnum.ACCOUNT_TPSL_HISTORY]: 60000,
  [AdminEndpointEnum.ACCOUNT_LATENCY]: 60000,
  [DeribitEndpointEnum.ACCOUNT_SUMMARY]: 60000,
  [DeribitEndpointEnum.ACCOUNT_POSITIONS]: 60000,
  [BinanceEndpointEnum.ACCOUNT_POSITIONS]: 60000,
  [BybitEndpointEnum.ACCOUNT_POSITIONS]: 60000,
  [AevoEndpointEnum.MARKETS]: 60000,
  [AdminEndpointEnum.CHECK_STATE]: 10000,
  [AdminEndpointEnum.SYNC_STATE]: 10000,
  [AdminEndpointEnum.RISK_POSITIONS]: 10000,
  [AdminEndpointEnum.ACCOUNT_ISOLATED_HEALTH]: 10000,
  [AdminEndpointEnum.ACCOUNTS_ISOLATED_HEALTH]: 10000,
  [TradingParametersEndpointEnum.GET_TRADING_PARAMETERS]: 30000,
};
